import React, { useContext, useEffect, useState } from "react";
import { ProductContext } from "../../context";
import Popup from "../Popup";
import { Tabs } from './Tabs';


import { UserAccountProfile,
  UserAccountNoti,
} from './UserAccount';
import { UserAccountPayment } from "./UserAccountPayment";

import { UserAccountOrders } from "./UserAccountOrders";
import { UserAccountSubscriptions } from "./UserAccountSubscriptions";
import { UserAccountRefunds } from './UserAccountRefunds';



export default function Tabbed({
  fullscreen = false,
  theme,
  page='orders',
  history = 'null',
  tabsSettings,

  temp = false, //TODO: скрытие элементов для ффр
}) {

  const valueFromContext = useContext(ProductContext);



  let [state, setState] = useState(page);

    useEffect(() => {
      if (history && history.match.params.keyId && history.match.params.keyId !== state) {
        setState(history.match.params.keyId)
      }
    },[history]);


    const handleUrl = (newState) => {
        setState(newState)
        history.history.push(newState)
    };


    const tabsSettingsDefault = {
      tabs: [
        {
          label: <div className="">
            {valueFromContext && valueFromContext.user && <img
              src={valueFromContext.user["picture"]}
              data-radium="true"
              style={{
                borderRadius: "100%",
                width: 36,
                height: 36,
                marginRight: 13
              }}
            />}
            Profile
          </div>,
          value: 'profile',
          component: <UserAccountProfile/>,
        },
        {
          label: 'Orders',
          value: 'orders',
          component: <UserAccountOrders/>,
        },
        {
          label: 'Subscriptions',
          value: 'subscriptions',
          component: <UserAccountSubscriptions/>,
        },
        {
          label: 'Payment',
          value: 'payment',
          component: <UserAccountPayment/>,
        },
        {
          label: 'Notification',
          value: 'notification',
          component: <UserAccountNoti/>,
        },
        {
          label: 'My refunds',
          counter: 1,
          value: 'refunds',
          component: <UserAccountRefunds/>,
        },
      ]
    }


    tabsSettings = tabsSettings || tabsSettingsDefault;

    return (
      <Popup
        fullscreen={fullscreen}
        sb={false}
        theme={valueFromContext.getTheme()}
        title={()=>{
          return (<Tabs
            theme={valueFromContext.getTheme()}
            active={state}
            handleTab={(nw)=>{
              handleUrl(nw)
              // setState(nw)
            }}
            {...tabsSettings}
          />)}}
        sb={valueFromContext['sbShown']}
        handleClose={
          !temp ? ()=>handleUrl('/') : false
        }
      >

        {tabsSettings.tabs.map((oneTab)=>{
          if (oneTab['value'] === state) {
            return oneTab['component']
          }
        })}



    </Popup>
    )
  }





